import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface RemoveFromBlacklistProps {
  selectedItems: { urn: string }[];
  onBack: () => void;
  onRemove: () => void;
  isLoading: boolean;
  blacklistType: "accounts" | "companies";
}

function getItemsLabel(
  itemsCount: number,
  blacklistType: "accounts" | "companies",
) {
  if (blacklistType === "accounts") {
    return `account${itemsCount === 1 ? "" : "s"}`;
  }
  return itemsCount === 1 ? "company" : blacklistType;
}

export default function RemoveFromBlacklist({
  selectedItems,
  onBack,
  onRemove,
  isLoading,
  blacklistType,
}: RemoveFromBlacklistProps) {
  const isDesktop = useTwBreakpoint("lg");
  const itemsCount = selectedItems.length;

  const itemsLabel = getItemsLabel(itemsCount, blacklistType);
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title="Remove from blacklist?"
        subtitle={
          <>
            Are you sure you want to remove {itemsCount} {itemsLabel} from
            blacklist?
          </>
        }
      />

      <Footer className="items-center justify-end">
        <Button variant="secondary-black" onClick={onBack} disabled={isLoading}>
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          onClick={onRemove}
          isLoading={isLoading}
        >
          Remove {itemsLabel}
        </Button>
      </Footer>
    </>
  );
}
